import { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTissueQuery } from "../../../queries";
import { FormCard, LoadingSpinner } from "../../../component-library";
import { Lists } from "../../lists";

export function LabDashboard() {
    const navigate = useNavigate();
    const {
        labDashboardQuery: { data, isFetching, isSuccess },
    } = useTissueQuery({ queryType: "labDashboard" });
    const tissuesToBeGraded = data?.toBeGraded ?? [];
    const [hasFetched, setHasFetched] = useState<boolean>(false);

    useEffect(() => {
        if (!hasFetched && isFetching) {
            setHasFetched(true);
        }
    }, [hasFetched, isFetching]);

    if (isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <h1>Lab Dashboard</h1>
            <FormCard title={`Tissues to be Graded ${tissuesToBeGraded.length ? `(${tissuesToBeGraded.length})` : ""}`}>
                {tissuesToBeGraded.length ? (
                    <Table striped bordered hover>
                        <tbody>
                            {tissuesToBeGraded.map((tissue) => (
                                <tr
                                    key={tissue.id}
                                    onClick={() =>
                                        navigate(`/lists/${Lists.TissuesToBeGraded}/tissues/${tissue.id}/grading`)
                                    }
                                    className="clickable"
                                    tabIndex={0}
                                >
                                    <td>{tissue.number}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No tissues found for selected regions.</p>
                )}
            </FormCard>
        </Container>
    );
}
